export const initialUser = {
  loggedIn: false,
  email: '',
  name: '',
  surname: '',
  selectedProfile: {
    id: '',
    name: 'Default',
    yearCalc: true,
  },
  mfaEnabled: false,
  mfaType: '',
};

export const initialProfiles = [{
  name: "Default",
  id: "",
  yearCalc: true,
}];

export const initialIncome = {
  records: [{
    id: "",
    description: '',
    company: '',
    monthlyAmount: 0.00,
    weeklyAmount: 0.00,
  }],
  descriptions: [
    { id: "", label: 'Full-time Employment', value: 'full-time employment', category: "INCOME" },
    { id: "", label: 'Part-time Employment', value: 'part-time employment', category: "INCOME"}
  ],
  monthlyTotal: 0.00,
  weeklyTotal: 0.00,
};

export const initialExpense = {
  records: [{
    id: "",
    description: '',
    company: '',
    monthlyAmount: 0.00,
    weeklyAmount: 0.00,
  }],
  descriptions: [
    { id: "", label: 'Mortgage', value: 'mortgage', category: "EXPENSE"},
    { id: "", label: 'Rent', value: 'rent', category: "EXPENSE" },
    { id: "", label: 'Water bill', value: 'water bill', category: "EXPENSE" },
    { id: "", label: 'Electric', value: 'electric', category: "EXPENSE" },
    { id: "", label: 'Gas', value: 'gas', category: "EXPENSE" },
  ],
  monthlyTotal: 0.00,
  weeklyTotal: 0.00,
}

export const initialDebtRecord = {
  id: "",
  description: '',
  company: '',
  collector: '',
  apr: 0.00,
  minimumPayment: 0.00,
  amount: 0.00,
  percentageOfDebt: 0.0,
  monthlyOverall: 0.00,
  weeklyOverall: 0.00,
  period: 0,
  periodWeekly: 0,
  monthlyIndividual: 0.00,
  weeklyIndividual: 0.00,
  status: 2,
  currentBalance: 0.00,
  paymentHistory: [],
  weekly: false,
  noOfPayments:0,
  paymentsMade: 0,
  debitsAmount: 0.00,
  currentBalanceCalc: false,
}

export const initialDebt = {
  records: [initialDebtRecord],
  manual: false,
  weekly: false,
  repaymentType: 'PERCENTAGE',
  totalAmount: 0,
  totalCurrentBalance: 0.00,
  totalPeriod: 12,
  totalPerMonthOverall: 0.00,
  totalPerWeekOverall: 0.00,
  totalPerMonthIndividual: 0.00,
  totalPerWeekIndividual: 0.00,
  descriptions: [
    { id: "", label: 'Credit Card', value: 'credit-card', category: "DEBT" },
    { id: "", label: 'Arrears', value: 'rent-arears', category: "DEBT" },
    { id: "", label: 'Water bill', value: 'water-bill', category: "DEBT" },
    { id: "", label: 'Electric', value: 'electric', category: "DEBT" },
    { id: "", label: 'Gas', value: 'gas', category: "DEBT" },
  ],
}